import { Component, effect, input, InputSignal, output, OutputEmitterRef, viewChild } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { FormioComponent, FormioForm, FormioModule } from '@formio/angular';
import { startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { DynamicObservable } from '../../../core/classes/dynamic-observable';
import { IFormioChangeEvent, IFormioSubmitEvent } from './scw-formio.interface';

@Component({
  imports: [FormioModule],
  selector: 'app-scw-formio',
  styleUrls: ['./scw-formio.component.scss'],
  templateUrl: './scw-formio.component.html',
})
export class ScwFormioComponent {
  public formioComponent = viewChild(FormioComponent);

  public form: InputSignal<FormioForm> = input.required<FormioForm>();
  public submission: InputSignal<object | undefined> = input.required<object | undefined>();
  public submitted: OutputEmitterRef<IFormioSubmitEvent> = output<IFormioSubmitEvent>();
  public changed: OutputEmitterRef<IFormioChangeEvent> = output<IFormioChangeEvent>();
  private readonly draftDynamicObs = new DynamicObservable<IFormioSubmitEvent | undefined>(undefined);
  private readonly isValidDynamicObs = new DynamicObservable<boolean>(false);
  public readonly draft = outputFromObservable(this.draftDynamicObs.obs$);
  public readonly isValid = outputFromObservable(this.isValidDynamicObs.obs$);

  constructor() {
    effect(() => {
      const formioComponent = this.formioComponent();

      if (!formioComponent) {
        return;
      }

      this.draftDynamicObs.switch(
        formioComponent.change.pipe(
          map(() => (formioComponent.formio as { _submission: object })?._submission as IFormioSubmitEvent),
          startWith((formioComponent.formio as { _submission: object })?._submission as IFormioSubmitEvent),
        ),
      );

      this.isValidDynamicObs.switch(
        formioComponent.change.pipe(
          map(
            () =>
              !(formioComponent.formio as { childErrors: object[] })?.childErrors?.length &&
              !(formioComponent.formio as { errors: object[] })?.errors?.length,
          ),
          startWith(
            !(formioComponent.formio as { childErrors: object[] })?.childErrors?.length &&
              !(formioComponent.formio as { errors: object[] })?.errors?.length,
          ),
        ),
      );
    });
  }

  public onSubmitForm($event: object): void {
    this.submitted.emit($event as IFormioSubmitEvent);
  }

  public onChangeForm($event: object): void {
    this.changed.emit($event as IFormioChangeEvent);
  }
}
